import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=e5bcdfd6&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=e5bcdfd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bcdfd6",
  null
  
)

export default component.exports